import { CheckCircle2, Clock, AlertTriangle, FileDiff, CircleDot } from "lucide-react";
import { STATUS_META } from "../lib/format";

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  red: "bg-red-50 text-red-700 border-red-200",
  indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
  slate: "bg-slate-100 text-slate-600 border-slate-200",
};

const ICONS = {
  paid: CheckCircle2,
  partially_paid: Clock,
  expected: CircleDot,
  overdue: AlertTriangle,
  difference: FileDiff,
  explained: CheckCircle2,
};

export function StatusBadge({ status, testId }) {
  const meta = STATUS_META[status] || STATUS_META.expected;
  const Icon = ICONS[status] || CircleDot;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${TONES[meta.tone]}`}
    >
      <Icon size={13} strokeWidth={2.4} />
      {meta.label}
    </span>
  );
}

const ALERT_TONES = {
  difference: { box: "bg-red-50 border-red-200", icon: "text-red-600", Icon: FileDiff },
  overdue: { box: "bg-red-50 border-red-300", icon: "text-red-600", Icon: AlertTriangle },
  awaiting: { box: "bg-amber-50 border-amber-200", icon: "text-amber-600", Icon: AlertTriangle },
  soon: { box: "bg-indigo-50 border-indigo-200", icon: "text-indigo-600", Icon: Clock },
};

export function AlertRow({ alert, onClick }) {
  const t = ALERT_TONES[alert.severity] || ALERT_TONES.soon;
  const Icon = t.Icon;
  return (
    <button
      onClick={onClick}
      data-testid={`alert-${alert.severity}-${alert.practice_id}`}
      className={`w-full text-left flex items-center gap-3 p-4 rounded-2xl border ${t.box} df-pressable`}
    >
      <span className={`shrink-0 ${t.icon}`}>
        <Icon size={20} strokeWidth={2.2} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-semibold text-slate-900 text-sm font-num">{alert.title}</span>
        <span className="block text-xs text-slate-500 truncate">{alert.subtitle}</span>
      </span>
      <span className="text-slate-300 text-lg">›</span>
    </button>
  );
}
